import React from 'react';
import clsx from 'clsx';

const pillTypeStyles: Record<string, string> = {
  // Country
  country: 'bg-neutral-100 text-deep-blue-700',
  selectedFilterCountry: 'bg-neutral-100 text-deep-blue-700',
  // Service
  service: 'bg-neutral-100 text-deep-blue-700',
  selectedFilterService: 'bg-neutral-100 text-deep-blue-700',
  // Technology
  technology: 'bg-neutral-100 text-deep-blue-700',
  selectedFilterTechnology: 'bg-neutral-100 text-deep-blue-700',
  // Compliance
  compliance: 'bg-neutral-100 text-deep-blue-700',
  selectedFilterCompliance: 'bg-neutral-100 text-deep-blue-700',
  // Therapeutic
  therapeutic: 'bg-neutral-100 text-deep-blue-700',
  selectedFilterTherapeutic: 'bg-neutral-100 text-deep-blue-700',
  // Platform
  platform: 'bg-neutral-100 text-deep-blue-700',
  selectedFilterPlatform: 'bg-neutral-100 text-deep-blue-700',
  // CRO
  cro: 'bg-neutral-100 text-deep-blue-700',
  selectedFilterCRO: 'bg-neutral-100 text-deep-blue-700',
  // Instrument
  instrument: 'bg-neutral-100 text-deep-blue-700',
  selectedFilterInstrument: 'bg-neutral-100 text-deep-blue-700',
  // Software
  software: 'bg-neutral-100 text-deep-blue-700',
  selectedFilterSoftware: 'bg-neutral-100 text-deep-blue-700',
  // Resolution
  resolution: 'bg-neutral-100 text-deep-blue-700',
  selectedFilterResolution: 'bg-neutral-100 text-deep-blue-700',
  platformResolution: 'bg-neutral-100 text-deep-blue-700',
  // Slide Resolution
  slideResolution: 'bg-neutral-100 text-deep-blue-700',
  selectedFilterSlideResolution: 'bg-neutral-100 text-deep-blue-700',
  platformSlideResolution: 'bg-neutral-100 text-deep-blue-700',
  // Application
  application: 'bg-neutral-100 text-deep-blue-700',
  selectedFilterApplication: 'bg-neutral-100 text-deep-blue-700',
  platformApplication: 'bg-neutral-100 text-deep-blue-700',
  // Throughput
  throughput: 'bg-neutral-100 text-deep-blue-700',
  selectedFilterThroughput: 'bg-neutral-100 text-deep-blue-700',
  platformThroughput: 'bg-neutral-100 text-deep-blue-700',
  // Platform-specific pills
  platformTechnology: 'bg-neutral-100 text-deep-blue-700',
  platformSample: 'bg-neutral-100 text-deep-blue-700',
  platformReadout: 'bg-neutral-100 text-deep-blue-700',
  platformPlexType: 'bg-neutral-100 text-deep-blue-700',
  platformChemistry: 'bg-neutral-100 text-deep-blue-700',
  // Sample types
  selectedFilterSample: 'bg-neutral-100 text-deep-blue-700',
  // Product-specific pills
  productSampleTypes: 'bg-neutral-100 text-deep-blue-700',
  productSlideResolution: 'bg-neutral-100 text-deep-blue-700',
  productCellularResolution: 'bg-neutral-100 text-deep-blue-700',
  productTechnology: 'bg-neutral-100 text-deep-blue-700',
  productPlatform: 'bg-neutral-100 text-deep-blue-700',
  productCategory: 'bg-neutral-100 text-deep-blue-700',
  productApplication: 'bg-neutral-100 text-deep-blue-700',
  // Additional pill types
  readout: 'bg-neutral-100 text-deep-blue-700',
  modality: 'bg-neutral-100 text-deep-blue-700',
  plexType: 'bg-neutral-100 text-deep-blue-700',
  markers: 'bg-neutral-100 text-deep-blue-700',
  speciesCompatibility: 'bg-neutral-100 text-deep-blue-700',
  offTheShelfCustom: 'bg-neutral-100 text-deep-blue-700',
  chemistry: 'bg-neutral-100 text-deep-blue-700',
  compatibleSamples: 'bg-neutral-100 text-deep-blue-700',
  compatibleAssays: 'bg-neutral-100 text-deep-blue-700',
  licenseType: 'bg-neutral-100 text-deep-blue-700',
  // Instrument Type pills with distinct colors
  instrumentType: 'bg-neutral-100 text-deep-blue-700',
  instrumentTypeFullyIntegratedSolution: 'bg-emerald-100 text-emerald-800',
  instrumentTypeDigitalMolecularBarcoder: 'bg-purple-100 text-purple-800',
  instrumentTypeAutostainer: 'bg-blue-100 text-blue-800',
  instrumentTypeSlideScanner: 'bg-cyan-100 text-cyan-800',
  instrumentTypeMicroscope: 'bg-green-100 text-green-800',
  // Fallbacks
  selectedFilter: 'bg-neutral-100 text-deep-blue-700',
  fallback: 'bg-neutral-100 text-deep-blue-700',
};

interface PillProps {
  type?: keyof typeof pillTypeStyles;
  children: React.ReactNode;
  className?: string;
}

export function Pill({ type = 'fallback', children, className }: PillProps) {
  return (
    <span
      className={clsx(
        'inline-flex items-center justify-center rounded-md px-3 py-1.5 text-sm font-medium min-h-[28px]',
        pillTypeStyles[type] || pillTypeStyles.fallback,
        className
      )}
    >
      {children}
    </span>
  );
} 